var _rect, _g, _rect2, _rect3, _rect4, _path, _rect5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 64,
    viewBox: "0 0 176 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_702_2975",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -6,
    y: 6,
    width: 188,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 18,
    width: 164,
    height: 40,
    rx: 20,
    stroke: "url(#paint0_angular_702_2975)",
    strokeWidth: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_702_2975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3403 51.5093C26.5418 51.0603 26.1089 50.6263 25.6611 50.8283C25.564 50.8732 25.4894 50.9481 25.4446 51.0453C25.2356 51.4944 25.676 51.9284 26.1238 51.7264C26.2209 51.6815 26.2955 51.6066 26.3403 51.5093Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4892 48.732C14.6907 48.283 14.2578 47.8489 13.81 48.051C13.713 48.0959 13.6383 48.1707 13.5935 48.268C13.3846 48.717 13.8249 49.1511 14.2727 48.949C14.3698 48.9041 14.4444 48.8293 14.4892 48.732Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4891 36.732C37.6911 36.283 37.2571 35.8489 36.808 36.051C36.7108 36.0959 36.6359 36.1707 36.591 36.268C36.3889 36.717 36.823 37.1511 37.272 36.949C37.3693 36.9041 37.4442 36.8293 37.4891 36.732Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9492 48.6905C51.1507 48.2415 50.7178 47.8074 50.2699 48.0095C50.1729 48.0544 50.0983 48.1292 50.0535 48.2265C49.8445 48.6755 50.2849 49.1096 50.7327 48.9075C50.8297 48.8626 50.9044 48.7878 50.9492 48.6905Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5935 58.732C42.3846 58.283 42.8249 57.8489 43.2728 58.051C43.3698 58.0959 43.4444 58.1707 43.4892 58.268C43.6907 58.717 43.2578 59.1511 42.81 58.949C42.7129 58.9041 42.6383 58.8293 42.5935 58.732Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5935 62.732C17.3846 62.283 17.8249 61.8489 18.2727 62.051C18.3698 62.0959 18.4444 62.1707 18.4892 62.268C18.6907 62.717 18.2578 63.1511 17.81 62.949C17.713 62.9041 17.6383 62.8293 17.5935 62.732Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3403 15.5093C28.5418 15.0603 28.1089 14.6263 27.6611 14.8283C27.564 14.8732 27.4894 14.9481 27.4446 15.0453C27.2356 15.4944 27.676 15.9284 28.1238 15.7264C28.2209 15.6815 28.2955 15.6066 28.3403 15.5093Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4892 12.732C16.6907 12.283 16.2578 11.8489 15.81 12.051C15.713 12.0959 15.6383 12.1707 15.5935 12.268C15.3846 12.717 15.8249 13.1511 16.2727 12.949C16.3698 12.9041 16.4444 12.8293 16.4892 12.732Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5935 22.732C44.3846 22.283 44.8249 21.8489 45.2728 22.051C45.3698 22.0959 45.4444 22.1707 45.4892 22.268C45.6907 22.717 45.2578 23.1511 44.81 22.949C44.7129 22.9041 44.6383 22.8293 44.5935 22.732Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5935 26.732C19.3846 26.283 19.8249 25.8489 20.2727 26.051C20.3698 26.0959 20.4444 26.1707 20.4892 26.268C20.6907 26.717 20.2578 27.1511 19.81 26.949C19.713 26.9041 19.6383 26.8293 19.5935 26.732Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.949164 33.6905C1.15069 33.2415 0.717779 32.8074 0.269942 33.0095C0.172911 33.0544 0.098288 33.1292 0.0535044 33.2265C-0.155486 33.6755 0.284866 34.1096 0.732703 33.9075C0.829734 33.8626 0.90438 33.7878 0.949164 33.6905Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94916 53.6905C5.15069 53.2415 4.71778 52.8074 4.26994 53.0095C4.17291 53.0544 4.09829 53.1292 4.0535 53.2265C3.84451 53.6755 4.28487 54.1096 4.7327 53.9075C4.82973 53.8626 4.90438 53.7878 4.94916 53.6905Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59088 21.7086C6.38935 21.2595 6.82225 20.8255 7.27008 21.0275C7.36711 21.0724 7.44175 21.1473 7.48654 21.2446C7.69553 21.6936 7.25515 22.1277 6.80732 21.9256C6.71029 21.8807 6.63566 21.8058 6.59088 21.7086Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.591 36.732C11.3889 36.283 11.823 35.8489 12.272 36.051C12.3693 36.0959 12.4442 36.1707 12.4891 36.268C12.6911 36.717 12.2571 37.1511 11.808 36.949C11.7107 36.9041 11.6359 36.8293 11.591 36.732Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.489 61.732C132.691 61.283 132.258 60.8489 131.81 61.051C131.713 61.0959 131.638 61.1707 131.594 61.268C131.385 61.717 131.825 62.1511 132.273 61.949C132.37 61.9041 132.444 61.8293 132.489 61.732Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.591 37.7086C142.389 37.2595 142.822 36.8255 143.27 37.0275C143.367 37.0724 143.442 37.1473 143.487 37.2446C143.696 37.6936 143.255 38.1277 142.807 37.9256C142.71 37.8807 142.636 37.8058 142.591 37.7086Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.591 62.732C155.389 62.283 155.823 61.8489 156.272 62.051C156.369 62.0959 156.444 62.1707 156.489 62.268C156.691 62.717 156.257 63.1511 155.808 62.949C155.711 62.9041 155.636 62.8293 155.591 62.732Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.591 45.732C162.389 45.283 162.823 44.8489 163.272 45.051C163.369 45.0959 163.444 45.1707 163.489 45.268C163.691 45.717 163.257 46.1511 162.808 45.949C162.711 45.9041 162.636 45.8293 162.591 45.732Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.364 49.1783C146.565 48.7293 146.132 48.2952 145.685 48.4973C145.587 48.5422 145.513 48.617 145.468 48.7143C145.259 49.1633 145.699 49.5974 146.147 49.3953C146.244 49.3504 146.319 49.2756 146.364 49.1783Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.489 25.732C134.691 25.283 134.258 24.8489 133.81 25.051C133.713 25.0959 133.638 25.1707 133.594 25.268C133.385 25.717 133.825 26.1511 134.273 25.949C134.37 25.9041 134.444 25.8293 134.489 25.732Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.949 12.6905C125.151 12.2415 124.718 11.8074 124.27 12.0095C124.173 12.0544 124.098 12.1292 124.054 12.2265C123.845 12.6755 124.285 13.1096 124.733 12.9075C124.83 12.8626 124.904 12.7878 124.949 12.6905Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.591 26.732C157.389 26.283 157.823 25.8489 158.272 26.051C158.369 26.0959 158.444 26.1707 158.489 26.268C158.691 26.717 158.257 27.1511 157.808 26.949C157.711 26.9041 157.636 26.8293 157.591 26.732Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.591 9.732C164.389 9.28297 164.823 8.84891 165.272 9.05097C165.369 9.09587 165.444 9.17071 165.489 9.268C165.691 9.71703 165.257 10.1511 164.808 9.94903C164.711 9.90413 164.636 9.82929 164.591 9.732Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.364 13.1783C148.565 12.7293 148.132 12.2952 147.685 12.4973C147.587 12.5422 147.513 12.617 147.468 12.7143C147.259 13.1633 147.699 13.5974 148.147 13.3953C148.244 13.3504 148.319 13.2756 148.364 13.1783Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.949 35.6905C162.151 35.2415 161.718 34.8074 161.27 35.0095C161.173 35.0544 161.098 35.1292 161.054 35.2265C160.845 35.6755 161.285 36.1096 161.733 35.9075C161.83 35.8626 161.904 35.7878 161.949 35.6905Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.591 25.7086C173.389 25.2595 173.822 24.8255 174.27 25.0275C174.367 25.0724 174.442 25.1473 174.487 25.2446C174.696 25.6936 174.255 26.1277 173.807 25.9256C173.71 25.8807 173.636 25.8058 173.591 25.7086Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.591 46.732C174.389 46.283 174.823 45.8489 175.272 46.051C175.369 46.0959 175.444 46.1707 175.489 46.268C175.691 46.717 175.257 47.1511 174.808 46.949C174.711 46.9041 174.636 46.8293 174.591 46.732Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_702_2975)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 19,
    width: 162,
    height: 38,
    rx: 19,
    stroke: "url(#paint1_angular_702_2975)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 19,
    width: 162,
    height: 38,
    rx: 19,
    stroke: "url(#paint2_angular_702_2975)",
    strokeWidth: 2
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 18.5,
    width: 163,
    height: 39,
    rx: 19.5,
    stroke: "url(#paint3_angular_702_2975)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 18,
    width: 164,
    height: 40,
    rx: 20,
    fill: "white",
    fillOpacity: 0.01
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 18,
    width: 164,
    height: 40,
    rx: 20,
    fill: "url(#paint4_radial_702_2975)",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.561 43.21C46.5577 43.21 45.7107 42.9883 45.02 42.545C44.3293 42.097 43.8067 41.4787 43.452 40.69C43.0973 39.9013 42.92 38.9913 42.92 37.96C42.92 36.9287 43.0973 36.0187 43.452 35.23C43.8067 34.4413 44.3293 33.8253 45.02 33.382C45.7107 32.934 46.5577 32.71 47.561 32.71C48.7323 32.71 49.689 33.011 50.431 33.613C51.173 34.2103 51.6817 35.013 51.957 36.021L50.907 36.294C50.6923 35.496 50.3073 34.8637 49.752 34.397C49.1967 33.9303 48.4663 33.697 47.561 33.697C46.7723 33.697 46.1167 33.8767 45.594 34.236C45.0713 34.5953 44.677 35.097 44.411 35.741C44.1497 36.3803 44.0143 37.12 44.005 37.96C44.0003 38.8 44.1287 39.5397 44.39 40.179C44.656 40.8183 45.0527 41.32 45.58 41.684C46.112 42.0433 46.7723 42.223 47.561 42.223C48.4663 42.223 49.1967 41.9897 49.752 41.523C50.3073 41.0517 50.6923 40.4193 50.907 39.626L51.957 39.899C51.6817 40.907 51.173 41.712 50.431 42.314C49.689 42.9113 48.7323 43.21 47.561 43.21ZM58.1425 43.21C57.1392 43.21 56.2922 42.9883 55.6015 42.545C54.9108 42.097 54.3882 41.4787 54.0335 40.69C53.6788 39.9013 53.5015 38.9913 53.5015 37.96C53.5015 36.9287 53.6788 36.0187 54.0335 35.23C54.3882 34.4413 54.9108 33.8253 55.6015 33.382C56.2922 32.934 57.1392 32.71 58.1425 32.71C59.1505 32.71 59.9975 32.934 60.6835 33.382C61.3742 33.8253 61.8968 34.4413 62.2515 35.23C62.6108 36.0187 62.7905 36.9287 62.7905 37.96C62.7905 38.9913 62.6108 39.9013 62.2515 40.69C61.8968 41.4787 61.3742 42.097 60.6835 42.545C59.9975 42.9883 59.1505 43.21 58.1425 43.21ZM58.1425 42.223C58.9312 42.223 59.5892 42.0433 60.1165 41.684C60.6438 41.3247 61.0382 40.8253 61.2995 40.186C61.5655 39.542 61.6985 38.8 61.6985 37.96C61.6985 37.12 61.5655 36.3803 61.2995 35.741C61.0382 35.1017 60.6438 34.6023 60.1165 34.243C59.5892 33.8837 58.9312 33.7017 58.1425 33.697C57.3538 33.697 56.6982 33.8767 56.1755 34.236C55.6528 34.5953 55.2585 35.097 54.9925 35.741C54.7312 36.3803 54.5982 37.12 54.5935 37.96C54.5888 38.8 54.7172 39.5397 54.9785 40.179C55.2445 40.8137 55.6412 41.313 56.1685 41.677C56.6958 42.0363 57.3538 42.2183 58.1425 42.223ZM64.7523 43V32.92H65.7883L71.3393 41.18V32.92H72.3753V43H71.3393L65.7883 34.733V43H64.7523ZM77.5773 43V33.907H74.0563V32.92H82.1273V33.907H78.6063V43H77.5773ZM82.8364 43L86.3084 32.92H87.6734L91.1454 43H90.0744L86.7774 33.494H87.1834L83.9074 43H82.8364ZM84.3834 40.557V39.591H89.5914V40.557H84.3834ZM96.777 43.21C95.7737 43.21 94.9267 42.9883 94.236 42.545C93.5453 42.097 93.0227 41.4787 92.668 40.69C92.3133 39.9013 92.136 38.9913 92.136 37.96C92.136 36.9287 92.3133 36.0187 92.668 35.23C93.0227 34.4413 93.5453 33.8253 94.236 33.382C94.9267 32.934 95.7737 32.71 96.777 32.71C97.9483 32.71 98.905 33.011 99.647 33.613C100.389 34.2103 100.898 35.013 101.173 36.021L100.123 36.294C99.9083 35.496 99.5233 34.8637 98.968 34.397C98.4127 33.9303 97.6823 33.697 96.777 33.697C95.9883 33.697 95.3327 33.8767 94.81 34.236C94.2873 34.5953 93.893 35.097 93.627 35.741C93.3657 36.3803 93.2303 37.12 93.221 37.96C93.2163 38.8 93.3447 39.5397 93.606 40.179C93.872 40.8183 94.2687 41.32 94.796 41.684C95.328 42.0433 95.9883 42.223 96.777 42.223C97.6823 42.223 98.4127 41.9897 98.968 41.523C99.5233 41.0517 99.9083 40.4193 100.123 39.626L101.173 39.899C100.898 40.907 100.389 41.712 99.647 42.314C98.905 42.9113 97.9483 43.21 96.777 43.21ZM105.959 43V33.907H102.438V32.92H110.509V33.907H106.988V43H105.959ZM119.064 43.21C118.294 43.21 117.613 43.0513 117.02 42.734C116.432 42.4167 115.97 41.9687 115.634 41.39C115.298 40.8113 115.13 40.1347 115.13 39.36V32.927L116.166 32.92V39.227C116.166 39.7497 116.255 40.2023 116.432 40.585C116.609 40.963 116.84 41.2757 117.125 41.523C117.414 41.7657 117.729 41.9453 118.07 42.062C118.411 42.1787 118.742 42.237 119.064 42.237C119.391 42.237 119.724 42.1787 120.065 42.062C120.406 41.9453 120.718 41.7657 121.003 41.523C121.288 41.2757 121.519 40.963 121.696 40.585C121.873 40.2023 121.962 39.7497 121.962 39.227V32.92H122.998V39.36C122.998 40.1347 122.83 40.8113 122.494 41.39C122.158 41.964 121.694 42.412 121.101 42.734C120.513 43.0513 119.834 43.21 119.064 43.21ZM128.596 43.21C127.892 43.21 127.257 43.0933 126.692 42.86C126.132 42.622 125.668 42.286 125.299 41.852C124.935 41.418 124.697 40.9023 124.585 40.305L125.635 40.13C125.803 40.7833 126.158 41.2967 126.699 41.67C127.241 42.0387 127.887 42.223 128.638 42.223C129.133 42.223 129.576 42.146 129.968 41.992C130.36 41.8333 130.668 41.6093 130.892 41.32C131.116 41.0307 131.228 40.6877 131.228 40.291C131.228 40.0297 131.182 39.808 131.088 39.626C130.995 39.4393 130.871 39.2853 130.717 39.164C130.563 39.0427 130.395 38.9423 130.213 38.863C130.031 38.779 129.854 38.7113 129.681 38.66L127.126 37.897C126.818 37.8083 126.534 37.6963 126.272 37.561C126.011 37.421 125.782 37.2553 125.586 37.064C125.395 36.868 125.246 36.6393 125.138 36.378C125.031 36.1167 124.977 35.818 124.977 35.482C124.977 34.9127 125.127 34.4203 125.425 34.005C125.724 33.5897 126.132 33.27 126.65 33.046C127.168 32.822 127.759 32.7123 128.421 32.717C129.093 32.717 129.693 32.836 130.22 33.074C130.752 33.312 131.191 33.6527 131.536 34.096C131.882 34.5347 132.11 35.055 132.222 35.657L131.144 35.853C131.074 35.4143 130.913 35.034 130.661 34.712C130.409 34.39 130.087 34.1427 129.695 33.97C129.308 33.7927 128.881 33.7017 128.414 33.697C127.962 33.697 127.558 33.774 127.203 33.928C126.853 34.0773 126.576 34.2827 126.37 34.544C126.165 34.8053 126.062 35.104 126.062 35.44C126.062 35.7807 126.156 36.0537 126.342 36.259C126.534 36.4643 126.767 36.6253 127.042 36.742C127.322 36.8587 127.593 36.9543 127.854 37.029L129.828 37.61C130.034 37.666 130.274 37.7477 130.549 37.855C130.829 37.9577 131.1 38.107 131.361 38.303C131.627 38.4943 131.847 38.7463 132.019 39.059C132.192 39.3717 132.278 39.7683 132.278 40.249C132.278 40.7157 132.185 41.1333 131.998 41.502C131.816 41.8707 131.557 42.181 131.221 42.433C130.89 42.685 130.5 42.8763 130.052 43.007C129.609 43.1423 129.124 43.21 128.596 43.21Z",
    fill: "url(#paint5_linear_702_2975)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 18.5,
    width: 163,
    height: 39,
    rx: 19.5,
    stroke: "white",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_702_2975",
    x: 0,
    y: 12,
    width: 176,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_702_2975"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_702_2975",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88 38) scale(110.522 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838542,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_702_2975",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88 38) scale(110.522 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838542,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_702_2975",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88 38) scale(110.522 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838542,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_angular_702_2975",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88 38) scale(110.522 62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838542,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_702_2975",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88 104) rotate(90) scale(43 176.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_702_2975",
    x1: 88,
    y1: 26,
    x2: 88,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885417,
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBtn);
export default __webpack_public_path__ + "static/media/contact_btn.a76387ffc7b11f2efe2d6806237c6f41.svg";
export { ForwardRef as ReactComponent };